// 会在项目中直接引用，不会被babel编译
const operator = {
    $gte(a, b) {
        return a >= b;
    },
    $gt(a, b) {
        return a > b;
    },
    $lte(a, b) {
        return a <= b;
    },
    $lt(a, b) {
        return a < b;
    },
};
let SIMILARITY_CONFIG = [
    {
        $gte: 0.99,
        color: '#900A0A',
        klass: 'one',
    },
    {
        $lt: 0.99,
        $gte: 0.97,
        color: '#d0021b',
        klass: 'two',
    },
    {
        $lt: 0.97,
        $gte: 0.95,
        color: '#ff565d',
        klass: 'three',
    },
    {
        $lt: 0.95,
        $gte: 0.9,
        color: '#FFAE29',
        klass: 'four',
    },
    {
        $lt: 0.9,
        $gte: 0.8,
        color: '#F8E71C',
        klass: 'five',
    },
    {
        $lt: 0.8,
        $gte: 0.6,
        color: '#ADD9EB',
        klass: 'six',
    },
    {
        $lt: 0.6,
        $gt: 0,
        color: '#547DB9',
        klass: 'seven',
    },
];
export const similarity = (value) => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0, size = SIMILARITY_CONFIG.length; i < size; i++) {
        const config = SIMILARITY_CONFIG[i];
        const keys = Object.keys(config).filter((key) => key !== 'color' && key !== 'klass');
        const bool = keys.every((key) => operator[key](Math.round(value * 10000) / 10000, config[key]));
        if (bool) {
            return config;
        }
    }
    return undefined;
};
export const setSimilartyConfig = (config) => {
    SIMILARITY_CONFIG = config;
};
export const calcColor = (matched, similarityValue) => {
    const a = matched.replace(/\s|\+/g, '').length;
    const value = similarityValue !== undefined ? similarityValue : a / matched.length;
    if (Number.isNaN(value)) {
        return {
            similarity: 0,
            color: '#999999',
        };
    }
    const config = similarity(value);
    return { similarity: value, ...config };
};
// define hit color 命中序列的文本的颜色配置
export const SIMILARITY_CONFIG_TEXT = [
    {
        $gte: 0.99,
        color: '#90090A',
        klass: 'one',
    },
    {
        $lt: 0.99,
        $gte: 0.97,
        color: '#D0021B',
        klass: 'two',
    },
    {
        $lt: 0.97,
        $gte: 0.95,
        color: '#FF565D',
        klass: 'three',
    },
    {
        $lt: 0.95,
        $gte: 0.9,
        color: '#DE7D00',
        klass: 'four',
    },
    {
        $lt: 0.9,
        $gte: 0.8,
        color: '#D2AC00',
        klass: 'five',
    },
    {
        $lt: 0.8,
        $gte: 0.6,
        color: '#16B4D3',
        klass: 'six',
    },
    {
        $lt: 0.6,
        $gte: 0,
        color: '#0154AE',
        klass: 'seven',
    },
];
export class SimilarityColor {
    constructor(config = SIMILARITY_CONFIG) {
        this.config = config;
        this.SIMILARITY_CONFIG = config;
    }
    setSimilarityConfig(config) {
        this.SIMILARITY_CONFIG = config;
    }
    similarity(value) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0, size = this.SIMILARITY_CONFIG.length; i < size; i++) {
            const config = this.SIMILARITY_CONFIG[i];
            const keys = Object.keys(config).filter((key) => key !== 'color' && key !== 'klass');
            ;
            const bool = keys.every((key) => operator[key](Math.round(value * 10000) / 10000, config[key]));
            if (bool) {
                return config;
            }
        }
        return undefined;
    }
    calcColor(matched, similarityValue) {
        const a = matched.replace(/\s|\+/g, '').length;
        const value = similarityValue !== undefined ? similarityValue : a / matched.length;
        if (Number.isNaN(value)) {
            return {
                similarity: 0,
                color: '#999999',
            };
        }
        const config = this.similarity(value);
        return { similarity: value, ...config };
    }
}
//# sourceMappingURL=similarity.js.map